import React, { useEffect, useState } from 'react';
import Header from '@components/Comman/Header';
import { Table, Tag, Button, Space, Modal, Row, Col, Input, Select, Card, Avatar, Empty, Spin } from 'antd';
import { EyeOutlined, LinkOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { appendRegisterReferrer, capitalizeAfterComma, capitalizeFirstLetter, formatAndCapitalizeString, getExistingBusinessCode, isValidEmail, truncateText } from '@utils/comman';
// import { businessCategories } from '@utils/contstant';
import './index.css'
import CustomCard from './CustomCard';
import BusinessListing from './FeatureCard';
import CardPagination from '@components/Comman/CardPagination';
import { getAllBusinessCategories, getReferUsNetworkBusinesses } from '../../actions/business';
import PageTitle from '@components/Comman/PageTitle';

interface DataType {
    key: string;
    firstName: string;
    lastName: string;
    email: string;
    businessCode: string;
    isRegistered: boolean;
}

const columns: ColumnsType<DataType> = [
    {
        title: 'Date Started',
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: (a: any, b: any) => a.createdAt?.localeCompare(b?.createdAt),
        render: (text) => {
            return <>{moment(text).format('DD/MM/YYYY')}</>
        }
    },
    {
        title: 'First Name',
        dataIndex: 'invite',
        key: 'invite',
        sorter: (a: any, b: any) => a.invite?.firstName?.localeCompare(b?.invite?.firstName),
        render: (text) => {
            return <>{text?.firstName}</>
        }
    },
    {
        title: 'Last Name',
        dataIndex: 'invite',
        key: 'invite',
        sorter: (a: any, b: any) => a.invite?.lastName.localeCompare(b?.invite?.lastName),
        render: (text) => {
            return <>{text?.lastName}</>
        },
    },
    {
        title: 'Contact Number',
        dataIndex: 'contactNumber',
        key: 'contactNumber',
        sorter: (a: any, b: any) => a?.contactNumber.localeCompare(b?.contactNumber),
        render: (text) => {
            return <>{text}</>
        },
    },
    {
        title: 'Email',
        dataIndex: 'invite',
        key: 'invite',
        sorter: (a: any, b: any) => a.invite?.email?.localeCompare(b.invite?.email),
        render: (text) => {
            return <>{text?.email}</>
        },
    },
    {
        title: 'Business Code',
        dataIndex: 'senderCode',
        key: 'senderCode',
        sorter: (a: any, b: any) => a?.senderCode?.localeCompare(b?.senderCode),
        render: (text) => <>{text}</>,
    },
    {
        title: 'No. Of Referrals',
        dataIndex: 'referralsCount',
        key: 'referralsCount',
        sorter: (a: any, b: any) => a?.referralsCount?.localeCompare(b?.referralsCount),
        render: (text) => <>{text}</>,
    },
   
    {
        title: 'No. Of Referrals',
        dataIndex: 'referralsCount',
        key: 'referralsCount',
        sorter: (a: any, b: any) => a?.referralsCount?.localeCompare(b?.referralsCount),
        render: (text) => <>{text}</>,
    },
    {
        title: 'Date of last referrals',
        dataIndex: 'lastDateOfReferrals',
        key: 'lastDateOfReferrals',
        sorter: (a: any, b: any) => a?.lastDateOfReferrals?.localeCompare(b?.lastDateOfReferrals),
        render: (text) => <>{text}</>,
    },
    {
        title: 'Outstanding Payment',
        dataIndex: 'outstandingPayment',
        key: 'outstandingPayment',
        sorter: (a: any, b: any) => a?.outstandingPayment?.localeCompare(b?.outstandingPayment),
        render: (text) => <>{text}</>,
    },
    {
        title: 'Total Income',
        dataIndex: 'totalIncome',
        key: 'totalIncome',
        sorter: (a: any, b: any) => a?.totalIncome?.localeCompare(b?.totalIncome),
        render: (text) => <>{text}</>,
    },
    {
        title: 'Action',
        key: 'action',
        render: (_, record) => (
            <Space size="middle">
                <Button type='link' onClick={() => console.log("View details", record)}>
                    <EyeOutlined />
                </Button>
            </Space>
        ),
    },
];

interface ReferrerType {
    adminId?: number
}

interface PayloadType {
    limit: number;
    page: number;
    role: number;
    admin_id?: number;
};

const ReferUsNetwork = ({ adminId }: ReferrerType) => {
    const [data, setData] = useState<DataType[]>([]);
    const { businessCategory } = useSelector((state:any) => state?.Business)
    const host = window?.location?.origin;
    const [pagination, setPagination] = useState({ totalItems: 0 });
    const [showConfirm, setShowConfirm] = useState(false)
    const [pageSize, setPageSize] = useState(12);
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    const userData = useSelector((state: any) => state?.Auth?.user);
    const businessList = useSelector((state: any) => state?.Business?.businessDetails);
    const userRoleId = userData?.data?.roleId;
    const { isLoading } = useSelector((state: any) => state?.General);
    const [searchValues, setSearchValues] = useState({ businessName: '', category: '', postcode: '', otherCategory : '' });



    const getBusinessIReferData =(payloadD: any)=> {
        let payload = { limit: pageSize, page: page, ...payloadD };

        if (userRoleId === 1) {
            payload = { ...payload, admin_id: adminId }
        }
        dispatch(
            getReferUsNetworkBusinesses(payload, (resp: any) => {
                if (resp?.status === 200) {
                    setData(resp?.data);
                    setPagination(resp?.pagination);
                }
            })
        );
    }
    
    useEffect(()=> {
        dispatch(getAllBusinessCategories({}, ()=>{}))
    }, [])

    useEffect(() => {
        let payload: PayloadType = { limit: pageSize, page, role: userRoleId };
        getBusinessIReferData(payload);
    }, [page, pageSize, dispatch]);

    const handleTableChange = (pagination: any) => {
        setPage(pagination);
    };

    const handleReferrerClick =(record: any)=> {
        let registerReferrerUrl:string = ''
        let busCode:any=record?.businessCode;
        let busName:any=record?.BusinessDetails?.businessName?.replace(/ /g, '_')
        let referrerCode:any=record?.senderCode;
        let businessData=record;

        if (referrerCode) {
            registerReferrerUrl = `${host}/business-details/register-referrer/${busName}/${busCode}?referrerCode=${referrerCode.toUpperCase()}`;
        } else {
            registerReferrerUrl = appendRegisterReferrer(record?.BusinessDetails?.url);
        }

        window.open(registerReferrerUrl, '_blank', 'noopener,noreferrer');
    }


    const superAdminColumns: ColumnsType<DataType> = [
        {
            title: 'First Name',
            dataIndex: 'firstName',
            key: 'firstName',
            sorter: (a: any, b: any) => a.firstName?.localeCompare(b?.firstName),
            render: (text) => {
                return <>{text}</>
            }
        },
        {
            title: 'Last Name',
            dataIndex: 'lastName',
            key: 'lastName',
            sorter: (a: any, b: any) => a.lastName.localeCompare(b?.lastName),
            render: (text) => {
                return <>{text}</>
            },
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            sorter: (a: any, b: any) => a.email?.localeCompare(b.email),
            render: (text) => {
                return <>{text}</>
            },
        },
        {
            title: 'Is Registered',
            dataIndex: 'isRegistered',
            key: 'isRegistered',
            sorter: (a: any, b: any) => Number(a?.isRegistered) - Number(b?.isRegistered),
            render: (text: any) => (
                <Tag color={text ? 'green' : 'red'}>
                    {text ? 'Yes' : 'No'}
                </Tag>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button type='link' onClick={() => console.log("View details", record)}>
                        <EyeOutlined />
                    </Button>
                </Space>
            ),
        },
    ];

    const columns: ColumnsType<DataType> = [
        {
            title: 'Business Name',
            dataIndex: 'BusinessDetails',
            key: 'BusinessDetails',
            render: (text) => {
            return <>{text?.businessName}</>
            },
        },
        {
            title: 'Description',
            dataIndex: 'BusinessDetails',
            key: 'BusinessDetails',
            render: (text) => {
                return <span title={text?.description}>{
                  text?.description && truncateText(capitalizeFirstLetter(capitalizeAfterComma(text?.description)))
                }</span>
            },
        },
        {
            title: 'Category',
            dataIndex: 'BusinessDetails',
            key: 'BusinessDetails',
            sorter: (a: any, b: any) => a?.BusinessDetails?.category?.localeCompare(b?.BusinessDetails?.category),
            render: (text) => <>{capitalizeFirstLetter(formatAndCapitalizeString(text?.category))}</>,
        },
        {
            title: 'PostCode',
            dataIndex: 'BusinessDetails',
            key: 'BusinessDetails',
            sorter: (a: any, b: any) => a?.BusinessDetails?.pinCode?.localeCompare(b?.BusinessDetails?.pinCode),
            render: (text) => <a href={`https://auspost.com.au/postcode/${text?.pinCode}`} title={'Click to view this postcode on Australiya Post'} target='_blank'>{text?.pinCode}</a>,
        },
        {
            title: 'State',
            dataIndex: 'BusinessDetails',
            key: 'BusinessDetails',
            sorter: (a: any, b: any) => a?.BusinessDetails?.state?.localeCompare(b?.BusinessDetails?.state),
            render: (text) => <>{text?.state}</>,
        },
        {
            title: 'Country',
            dataIndex: 'BusinessDetails',
            key: 'BusinessDetails',
            sorter: (a: any, b: any) => a?.BusinessDetails?.country?.localeCompare(b?.BusinessDetails?.country),
            render: (text) => <>{text?.country}</>,
        },
        {
            title: 'Promotion Page',
            dataIndex: 'BusinessDetails',
            key: 'BusinessDetails',
            sorter: (a: any, b: any) => a?.BusinessDetails?.url?.localeCompare(b?.BusinessDetails?.url),
            render: (text) => <a href={text?.url} target='_blank' title={'Promotional Page Link'}><LinkOutlined style={{ fontSize: '20px' }} /></a>,
        },
        {
            title: 'Become A Referrer',
            key: '',
            render: (_, record: any) => {
              return <Space size="middle">
                    {userRoleId !== 1  ? getExistingBusinessCode(record?.invite)?.length === 0 ?
                        <Button
                            type="primary"
                            className='btn btn-primary-md'
                            size='small'
                            onClick={() => {handleReferrerClick(record)}}
                        >
                            Become A Referrer
                        </Button>
                        : <Tag color="#87d068" style={{ height: '30px', color: 'white', padding: '0 10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            Active
                        </Tag>
                         : <Tag color="#87d068" style={{ height: '30px', color: 'white', padding: '0 10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            Active
                        </Tag>}
              </Space>
            },
        },
    ];


    const tableComponent = (
        <>
            <div className="responsivetable">
                <div className='item-wrapper'>
                    {data?.map((item:any, index:number) => {
                        return (
                            <BusinessListing isReferUsNetwork={true} data={item} key={index} />
                        )
                    })}
                </div>
                {data?.length === 0 && <div style={{ textAlign: 'center'}}><Empty /></div>}
            </div>

        </>
    );

    const handleSearch =()=> {
        let values = {...searchValues, page: 1};
        if(values.category == 'other'){
           values.category = values.otherCategory;
        }
       
        delete values.otherCategory;
        getBusinessIReferData(values);
    }

    const handleReset = () => {
        setSearchValues({
            businessName: '', category: '', postcode: '', otherCategory : ''
        });
        getBusinessIReferData({});
    };

    return (
        <div>
            <Header pagTitle="ReferUs Network" />
            <div style={{ padding: '0 32px'}}>
                <PageTitle pagTitle='' />
            </div>
            <Row className="contentBody" style={{ justifyContent: 'center', marginBottom: '0px' }}>
                <CustomCard />
            </Row>
            <Row style={{textAlign: 'center', display: 'contents'}}>
                <div className='card-below-title'>Become a Referrer for any of the businesses and get rewarded!</div>
            </Row>
            <div className="contentBody">
                <div className="bodycard">
                    <div className=''>
                        <Row gutter={[16, 16]} style={{ marginBottom: '16px', width: '100%' }}>
                            {/* Business Name Input */}
                            <Col span={6} sm={24} lg={6} xs={24}>
                                <Input
                                    placeholder="Enter business name"
                                    value={searchValues.businessName}
                                    style={{ height: '50px', marginBottom: '16px' }}
                                    onChange={(e) => setSearchValues({ ...searchValues, businessName: e?.target?.value })}
                                />
                            </Col>

                            {/* Business Category Select */}
                            <Col span={6} sm={24} lg={6} xs={24}>
                                <Select
                                    value={searchValues?.category || undefined} // Ensure this is undefined when no selection
                                    allowClear // Enable clear option
                                    style={{ width: '100%', height: '50px', marginBottom: '16px' }}
                                    onChange={(e) => setSearchValues({ ...searchValues, category: e })}
                                    placeholder="Business Category"
                                    showSearch
                                    filterOption={(input: any, option: any) => {
                                        return option?.children?.toLowerCase().includes(input.toLowerCase())
                                    }
                                    }
                                >
                                    {businessCategory?.map((item: any, index: number) => {
                                        return <Select.Option key={index} value={item?.value}>{item?.label}</Select.Option>
                                    })}
                                </Select>
                            {/* <Select
                                        showSearch
                                        value={searchValues?.category || undefined} // Ensure this is undefined when no selection
                                        allowClear // Enable clear option
                                        placeholder="Search and select a business category"
                                        style={{ width: '100%', height: '50px', marginBottom: '16px' }}
                                        onChange={(e) => setSearchValues({ ...searchValues, category: e })}
                                        filterOption={(input: any, option: any) => {
                                            return option?.label?.toLowerCase().includes(input.toLowerCase())
                                        }
                                        }
                                        options={updatedBusinessServiceList}
                                    /> */}
                            </Col>
                            {/* Conditionally render the Other Category input */}
                            {searchValues.category === 'other' && (
                                <Col span={6} sm={24} lg={6} xs={24}>
                                <Input
                                    placeholder="Enter other business category"
                                    value={searchValues.otherCategory}
                                    style={{ height: '50px', marginBottom: '16px' }}
                                    onChange={(e) => setSearchValues({ ...searchValues, otherCategory: e.target.value })}
                                />
                                </Col>
                            )}

                            {/* Postcode Input */}
                            <Col span={6} sm={24} lg={6} xs={24}>
                                <Input
                                    placeholder="PostCode"
                                    value={searchValues.postcode}
                                    style={{ height: '50px', marginBottom: '16px' }}
                                    onChange={(e) => setSearchValues({ ...searchValues, postcode: e?.target?.value })}
                                />
                            </Col>

                            {/* Search Button */}
                            <Col span={3} sm={12} xs={12} lg={3}>
                                <Button
                                    type="primary"
                                    className='btn btn-primary btn-filter'
                                    onClick={handleSearch}
                                >
                                    Search
                                </Button>
                            </Col>
                            <Col span={3} sm={12} xs={12} lg={3}>
                                <Button
                                    // size='large'
                                    onClick={handleReset}
                                    className='btn-filter reset'
                                >
                                    Reset
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    <div className="cardContentbody">
                     {isLoading ? <Spin style={{padding: '25px', textAlign: 'center', display: 'block'}}></Spin> : tableComponent}
                    </div>
                    <div>
                        <CardPagination activePage={page} total={pagination?.totalItems || 0} handleChange={handleTableChange} />
                    </div>
                </div>
            </div>
            <Modal
                open={showConfirm}
                title="Are you sure you want to become referrer?"
                onOk={() => setShowConfirm(!showConfirm)}
                onCancel={() =>setShowConfirm(!showConfirm)}
                footer={[
                    <Button key="back" className='btn btn-outline-primary-md' onClick={()=> setShowConfirm(!showConfirm)}>
                        Cancel
                    </Button>,
                    <Button key="submit" className='btn btn-primary-md' type="primary" loading={isLoading} onClick={() => setShowConfirm(!showConfirm)}>
                        Ok
                    </Button>
                ]}
            >
                Once you click Ok it won't be reverted.
            </Modal>
        </div>
    );
};

export default ReferUsNetwork;
